import React, { useCallback } from "react"
import styled from "styled-components"
import { Button } from "../../../../components/parts/buttons/button"
import { LogoPc } from "../../../../components/parts/logo/logoPc"
import { LogoSp } from "../../../../components/parts/logo/logoSp"
import {
  ResponsivePC,
  ResponsiveSP,
} from "../../../../components/parts/responsive"
import { Background } from "../../../../components/templates/header/components/background"
import { NoShrink } from "../../../../components/templates/header/pc/components/no-shrink"
import {
  HeaderLogoSize,
  HeaderLogoWidthForSP,
} from "../../../../components/templates/header/style/variables"
import store from "../../../../config/configureStore"
import { ThrowError } from "../../../../error/error"
import { EpisodeUrl } from "../../../../libs/internal-url"
import { NotificationActionDispatcher } from "../../../../libs/notifications"
import { JSONRPCClientBuilder } from "../../../../request/JSONRPCClientBuilder"
import {
  Episode,
  EpisodeRPC,
  Visiblity,
} from "../../../../rpcs/dist/EpisodeRPC"
import Color from "../../../../style/enum/color"
import { PostEpisodeService } from "../../services/post-episode.service"
import { container, IContainerProps } from "./container"
import { withRouter, RouteComponentProps } from "react-router-dom"

type IProps = RouteComponentProps & IContainerProps

const draftButtonText = (visibility: Visiblity): string => {
  if (visibility === Visiblity.Draft) {
    return "下書き更新"
  }
  return "下書き保存"
}

const saveButtonText = (visibility: Visiblity): string => {
  if (visibility === Visiblity.Public) {
    return "更新"
  }
  return "投稿"
}

const removeEpisodeCache = async (displayId: Episode["displayId"]) => {
  const episodeRPC = JSONRPCClientBuilder.build(EpisodeRPC)
  await episodeRPC.fetchEpisodeDetail({ displayId }, { cacheUsable: false })
}

const send = async (props: IProps, visibility: Visiblity) => {
  const editorState = store.getState().pages.editor
  const postEpisodeService = new PostEpisodeService(
    editorState.fetchData,
    editorState.currentEditingState,
  )
  props.actions.sending()
  try {
    const postData = await postEpisodeService.validateWithPost(visibility)
    NotificationActionDispatcher.SuccessNotification("保存しました")
    await removeEpisodeCache(postData.displayId)
    props.history.push(EpisodeUrl(postData))
  } catch (e) {
    props.actions.sendingFailed()
    ThrowError(e)
  }
}

export const Header = withRouter(
  container((props: IProps) => {
    // eslint-disable-next-line
    const onClickDraft = useCallback(() => send(props, Visiblity.Draft), [])
    // eslint-disable-next-line
    const onClickPublic = useCallback(() => send(props, Visiblity.Public), [])

    return (
      <Background fixed={true}>
        <NoShrink>
          <ResponsivePC>
            <LogoPc width={HeaderLogoSize} />
          </ResponsivePC>
          <ResponsiveSP>
            <LogoSp width={HeaderLogoWidthForSP} />
          </ResponsiveSP>
        </NoShrink>
        <Flex>
          <StyledButton
            color={Color.DIMGRAY}
            borderColor={Color.DIMGRAY}
            disabled={props.isSending}
            onClick={onClickDraft}
          >
            {props.isSending ? "送信中" : draftButtonText(props.visibility)}
          </StyledButton>
          <StyledButton
            backgroundColor={Color.BRAND}
            color={Color.WHITE}
            disabled={props.isSending}
            onClick={onClickPublic}
          >
            {props.isSending ? "送信中" : saveButtonText(props.visibility)}
          </StyledButton>
        </Flex>
      </Background>
    )
  }),
)

const Flex = styled(NoShrink)`
  display: flex;
  align-items: center;
`

const StyledButton = styled(Button)`
  min-width: 100px;
  & + & {
    margin-left: 10px;
  }
`
